import type { Texture } from "three";

export function imageBufferFromThreeTexture(texture: Texture, flipY: boolean): Uint8ClampedArray<ArrayBuffer> {
  const image = texture.image as CanvasImageSource & { width: number; height: number };
  if (!(!!image)) {
    console.assert(false);
  }
  if (!(image.width > 0 && image.height > 0)) {
    console.assert(false);
  }
  const canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;
  const ctx = canvas.getContext("2d", { willReadFrequently: true }) as CanvasRenderingContext2D;
  if (flipY) {
    ctx.translate(0, canvas.height);
    ctx.scale(1, -1);
  }
  ctx.drawImage(image, 0, 0);
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  // Don't wait for GC to free canvas
  canvas.width = 0;
  return imageData.data;
}
